// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2ozCw","loaderOuter":"PageOverlayLoader_loaderOuter__3Dv8o"};